<template>
  <span :class="`${prefixCls}__extra-redo`" @click="handleRedo">
    <SyncOutlined v-if="isFrameType" :spin="loading" />
    <RedoOutlined v-else :spin="loading" />
  </span>
</template>
<script lang="ts">
  import { defineComponent, ref } from 'vue';
  import { RedoOutlined, SyncOutlined } from '@ant-design/icons-vue';
  import { useDesign } from '@/hooks/web/useDesign';
  import { useTabs } from '@/hooks/web/useTabs';
  import { useAppFrame } from '@/hooks/useAppFrame'
  export default defineComponent({
    name: 'TabRedo',
    components: { RedoOutlined, SyncOutlined },

    setup() {
      const loading = ref(false);
      const { isFrameType } = useAppFrame()
      const { prefixCls } = useDesign('multiple-tabs-content');
      const { refreshPage } = useTabs();

      async function handleRedo() {
        loading.value = true;
        await refreshPage();
        setTimeout(() => {
          loading.value = false;
          // Animation execution time
        }, 1200);
      }
      return { prefixCls, handleRedo, loading, isFrameType };
    },
  });
</script>
